module.exports = __webpack_public_path__ + "img/breath_alarm@2x.b944174f.png";